"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var columnChart_1 = require("../../common/column-chart/columnChart");
var talkTimeChart_styles_1 = require("./talkTimeChart.styles");
var core_components_1 = require("@securityproducts/core-components");
var talkTime_i18n_1 = require("./talkTime.i18n");
function TalkTimeChart(props) {
    var strings = core_components_1.useLocalisation(talkTime_i18n_1.talkTimeTranslations, props.language);
    return (React.createElement(core_components_1.ChartSection, { heading: strings.talkTime, id: "talk-time" },
        React.createElement("div", { className: talkTimeChart_styles_1.chartsWrapper, id: "talk-time-charts" },
            React.createElement("div", { className: talkTimeChart_styles_1.border },
                React.createElement("div", { className: talkTimeChart_styles_1.chartWrapper },
                    React.createElement(columnChart_1.ColumnChart, { id: "talk-time-charts-talk-time", xAxis: strings.talkTime, firstValue: props.talkTime.average, secondValue: props.talkTime.maximum, maxValue: props.overallMaximum, single: false, language: props.language })))),
        React.createElement(core_components_1.ChartKey, { keys: [
                { label: strings.average, stroke: "#0085c7" },
                { label: strings.maximum, stroke: "#98dcfa" },
            ] })));
}
exports.TalkTimeChart = TalkTimeChart;
TalkTimeChart.defaultProps = {
    overallMaximum: undefined,
    talkTime: {
        average: undefined,
        maximum: undefined,
    },
};
